import { Injectable } from '@angular/core';
import { DataCancellationModel } from 'app/modules/common/entities/data-cancel-data.model';
import { RestResponse } from 'app/modules/common/entities/rest.response-generic.model';
import { ApiService } from 'app/modules/common/services/api.service';
import { Observable } from 'rxjs';
import API from '../../../modules/common/services/api.config.json';

@Injectable({
    providedIn: 'root'
})
export class RegistroService {

    constructor(
        private apiService: ApiService,
    ) { }


    /**
     * Cancel data
     */
    public cancelData(dataCancellationModel: DataCancellationModel): Observable<RestResponse<string | null>> {
        const url = API.Registro.cancelData as string;
        return this.apiService.post(url, dataCancellationModel);
    }

}
